import { render, staticRenderFns } from "./StandoffPopup.vue?vue&type=template&id=47f39898&"
import script from "./StandoffPopup.vue?vue&type=script&lang=js&"
export * from "./StandoffPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports